import { render, staticRenderFns } from "./DashboardGeneralConsent.vue?vue&type=template&id=9de82eea&scoped=true&"
import script from "./DashboardGeneralConsent.vue?vue&type=script&lang=js&"
export * from "./DashboardGeneralConsent.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGeneralConsent.vue?vue&type=style&index=0&id=9de82eea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de82eea",
  null
  
)

export default component.exports